import Dummy from '../../utils/dummy';
import Main from '../../types/enums/main';
import Rail from '../../classes/rail';
import generateChannelsRails from '../../utils/generic/generateChannelsRails';
import slidersObservable from '../sliders/slidersObservable';
import { Observable, merge } from 'rxjs';
import { store } from '../../store/store';

const WAITING_TIME = 100;

export default function initialObservable(useFilter: boolean = true) {
  let data: Rail[] = [];
  return merge(
    slidersObservable(''), 
    new Observable((subscriber) => {
      const [filterRail, channelsRail, nowOnTvRail] = generateChannelsRails();
      data.push(filterRail);
      data.push(channelsRail);
      data.push(nowOnTvRail);
      setTimeout(() => {
        const { user, keepWatching } = store.getState();
        if (!user.isAnonymous && !keepWatching.initialized) {
          const dummy = Dummy.getPhoto().data[0];
          dummy.dummy = true;
          data.push(dummy);
        } else if (keepWatching.data.length) {
          const keepWatchingRail = keepWatching.rail;
          if (keepWatchingRail) {
            data.push(keepWatchingRail);
          }
        }
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    })
  );
}
